import { useQuery } from 'react-query';
import { CUSTOMER_NOTES } from '../../constants/reactQuery.keys';
import CustomerNotes from '../../services/CustomerNotes';

const { getCustomerNotes } = CustomerNotes;

export function useCustomCustomerNotes(customerId: number) {
  return useQuery([CUSTOMER_NOTES, customerId], () => getCustomerNotes(customerId));
}
